// extracted by mini-css-extract-plugin
export default {"body":"LYwyp3v9RihC5GKAlMgX","link":"hC0Umzr5JzqDshFqY03Y","details":"QUJCL96cOBsnEDbnKUyX"};